<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="createTableData($event)"
></mt-filter>

<div
    class="report-messenger mt-4"
    *ngIf="tableConfig || message || systemError"
>
    <div class="header-container">
        <div class="header">
            <div class="float-left title">
                {{ "messenger-status" | lang | uppercase }}
            </div>
            <div class="float-right" *ngIf="canDownload">
                <app-button-icon
                    [image]="'download'"
                    [iconType]="'icon'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (clickHandler)="downloadExcel()"
                ></app-button-icon>
            </div>
        </div>
    </div>

    <div [ngClass]="{ 'body-container': tableConfig }">
        <!-- Message -->
        <div class="d-flex flex-row message" *ngIf="message">
            <img
                class="message-img"
                appImageSelector
                [imageType]="'icon'"
                [imageKey]="'error-red'"
                alt="error"
            />
            <span class="message-text">{{ message }}</span>
        </div>

        <app-system-error-message
            *ngIf="!!systemError"
            [message]="systemError"
        ></app-system-error-message>

        <div class="report-data">
            <app-main-table
                *ngIf="tableConfig"
                [tableConfig]="tableConfig"
            ></app-main-table>
        </div>
    </div>
</div>
